class HemsireIlacUygulamaRequests {
    UygAciklama: string = null;
    id: number = null;
    uygulananTarih: string = null;
    uygulananDoz: number = null;
    uygulamaDurumu: number = null;
}

export default HemsireIlacUygulamaRequests;
